import { createFileRoute } from '@tanstack/react-router';
import { IntegrationsPage } from '@/features/tenant-admin/pages';

export const Route = createFileRoute('/tenant-admin/integrations')({
  component: IntegrationsPage,
});
